import { VStack } from '@wegroup/design-system';
import React from 'react';
import { QuoteProductDocument } from '../../../../../../../../types/Quotes';
import OfferDetails from './OfferDetails';
import OfferExtraInfo from './OfferExtraInfo';
import OfferOptions from './OfferOptions';
import OfferRating from './OfferRating';

const OfferOverview: React.FC<{ documents?: QuoteProductDocument[] }> = ({
  documents,
}) => {
  return (
    <VStack flexGrow={1} p="6" align="stretch" spacing="4">
      <OfferDetails />
      <OfferOptions />
      <OfferRating />
      <OfferExtraInfo documents={documents} />
    </VStack>
  );
};

export default OfferOverview;
